<template>
    <div 
      ref="slideElement"
      class="slide-up-wrapper"
      :class="[customClass]"
      :style="wrapperStyle"
    >
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SlideUpComponent',
    props: {
      // 触发变量（整型，改变时触发动画）
      trigger: {
        type: Number,
        default: 0
      },
      // 初始偏移距离(px)
      offset: {
        type: Number,
        default: 30
      },
      // 动画时长(ms)
      duration: {
        type: Number,
        default: 800
      },
      // 延迟时间(ms)
      delay: {
        type: Number,
        default: 0
      },
      // 自定义类名
      customClass: {
        type: String,
        default: ''
      },
      // 触发阈值（0-1，元素出现多少比例时触发）
      threshold: {
        type: Number,
        default: 0.1
      },
      // 是否只触发一次（true：滚动触发一次；false：每次进入视口都触发）
      once: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isAnimated: false,
        hasScrolledAnimated: false,
        observer: null,
        lastTriggerValue: this.trigger
      }
    },
    computed: {
      wrapperStyle() {
        if (this.isAnimated) {
          return {
            opacity: 1,
            transform: 'translateY(0)',
            transition: `opacity ${this.duration}ms cubic-bezier(0.4, 0, 0.2, 1) ${this.delay}ms, transform ${this.duration}ms cubic-bezier(0.4, 0, 0.2, 1) ${this.delay}ms`
          }
        } else {
          return {
            opacity: '0',
            transform: `translateY(${this.offset}px)`,
          }
        }
      }
    },
    watch: {
      // 监听trigger变量变化
      trigger: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.triggerAnimation()
          }
        },
        immediate: false
      }
    },
    mounted() {
      this.initObserver()
    },
    beforeDestroy() {
      if (this.observer) {
        this.observer.disconnect()
      }
    },
    methods: {
      // 初始化滚动观察器
      initObserver() {
        // 如果已经触发过且设置为只触发一次，就不需要再观察
        if (this.once && this.hasScrolledAnimated) return
  
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.isAnimated = true
                this.hasScrolledAnimated = true
                
                // 如果设置为只触发一次，停止观察
                if (this.once) {
                  this.observer.unobserve(this.$refs.slideElement)
                }
              } else if (!this.once) {
                // 如果不是只触发一次，离开视口时隐藏
                this.isAnimated = false
              }
            })
          },
          {
            threshold: this.threshold
          }
        )
  
        if (this.$refs.slideElement) {
          this.observer.observe(this.$refs.slideElement)
        }
      },
      
      // 变量改变触发动画
      triggerAnimation() {
        // 先隐藏
        this.isAnimated = false
        
        // 强制重绘
        if (this.$refs.slideElement) {
          this.$refs.slideElement.offsetHeight
        }
        
        // 下一帧显示，产生动画效果
        this.$nextTick(() => {
          setTimeout(() => {
            this.isAnimated = true
          }, 100)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .slide-up-wrapper {
    width: 100%;
    will-change: transform, opacity;
  }
  </style>